const zeroColour = '#c2c2c2';

const colourScale = {
    thresholds: [20, 40, 60, 80],
    colours: [
        '#ffffd4',
        '#fee391',
        '#fed230',
        '#fd9726',
        '#e6650f',
    ],
};

const getColour = (val) => {
    if (!val || val === '0') return zeroColour;
    const { thresholds, colours } = colourScale;
    for (let i = 0; i < thresholds.length; i++) {
        if (val <= thresholds[i]) return colours[i];
    }
    return colours[colours.length - 1];
};

export default {
    colourScale,
    getColour,
};
